class ColorBenefits extends HTMLElement {
  constructor() {
    super();
    const color_benefits_btn = this.querySelector('.color_benefits_button'); 

    color_benefits_btn.addEventListener('click', (event) => {
      event.preventDefault();
      document.body.classList.add('color_benefits_panel_active');      
    });

    const color_benefits_btn_close = this.querySelector('.color_benefits_facets__close'); 

    color_benefits_btn_close.addEventListener('click', (event) => {
      event.preventDefault();
      document.body.classList.remove('color_benefits_panel_active');      

    }); 
    
    /*
    const color_benefits_btn_close_section = this.querySelector('.color_benefits_info_section'); 

    color_benefits_btn_close_section.addEventListener('click', (event) => {
      event.preventDefault();
      document.body.classList.remove('color_benefits_panel_active');      
   
    });     
    */

  }
}

customElements.define('color-benefits', ColorBenefits);



class SizeGuide extends HTMLElement {
  constructor() {
    super();
    const size_guide_btn = this.querySelector('.size_guide_button'); 

    size_guide_btn.addEventListener('click', (event) => {
      event.preventDefault();
      document.body.classList.add('size_guide_panel_active');      
    });

    const size_guide_btn_close = this.querySelector('.size_guide_facets__close'); 

    size_guide_btn_close.addEventListener('click', (event) => {
      event.preventDefault();
      document.body.classList.remove('size_guide_panel_active');      

    }); 
 

  }
}

customElements.define('size-guide', SizeGuide);